module.exports = __webpack_public_path__ + "static/media/selectedTicketOfficeIcon.6bd50d74.png";